import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavigation from '../navigation/AdminNavigation';
import { useAdminAccess } from '../../../Hooks/useAdminAccess';
import '../../../admin.css';

/**
 * Admin Layout Component
 * Provides consistent layout for all admin pages with navigation
 */
const AdminLayout = () => {
  const { hasAdminAccess } = useAdminAccess();

  if (!hasAdminAccess()) {
    return (
      <div className="admin-layout admin-layout--unauthorized">
        <div className="admin-layout__error">
          <h1>Access Denied</h1>
          <p>You don't have permission to access the admin panel.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      <aside className="admin-layout__sidebar">
        <AdminNavigation />
      </aside>
      <main className="admin-layout__main">
        <div className="admin-layout__content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
